import _toConsumableArray from './../../external_lib/@babel/runtime/helpers/esm/toConsumableArray.js';
import { PresetColors } from '../theme/interface/presetColors.js';
const inverseColors = PresetColors.map(color => `${color}-inverse`);
/**
 * determine if the color keyword belongs to the `Ant Design` {@link PresetColors}.
 * @param color color to be judged
 * @param includeInverse whether to include reversed colors
 */
function isPresetColor(color) {
  let includeInverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (includeInverse) {
    return [].concat(_toConsumableArray(inverseColors), _toConsumableArray(PresetColors)).includes(color);
  }
  return PresetColors.includes(color);
}
export { isPresetColor };
//# sourceMappingURL=colors.js.map
